<template>
  <button
    :class="[$style.arrow, { [$style.big]: isBig }]"
    @click="$emit('go', direction)"
  >
    <component
      :is="`Chevron${direction}`"
      class="icon-white"
      :width="isBig ? '20px' : '15px'"
      :height="isBig ? '20px' : '15px'"
    />
  </button>
</template>

<script>
import ChevronRight from 'LkIcons/ChevronRight.vue'
import ChevronLeft from 'LkIcons/ChevronLeft.vue'

export default {
  name: 'CarouselArrow',
  components: {
    ChevronRight,
    ChevronLeft,
  },
  props: {
    direction: {
      type: String,
      required: true,
    },
    isBig: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" module>
.arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;

  background-color: $bluko-700;
  cursor: pointer;
}
.big {
  width: 40px;
  height: 40px;
}
</style>
